import { render, staticRenderFns } from "./EditXDu.vue?vue&type=template&id=5ff9be72&scoped=true&"
import script from "./EditXDu.vue?vue&type=script&lang=js&"
export * from "./EditXDu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9be72",
  null
  
)

export default component.exports